import type { IconSvgObject } from './types';

const Building02Icon: IconSvgObject = [
  ["path", { d: "M19 22V4.00001C19 2.89544 18.1046 2.00001 17 2.00001L7 2C5.89543 2 5 2.89543 5 4V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M3 22H21", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M14.5 22V18C14.5 17.4477 14.0523 17 13.5 17H10.5C9.94772 17 9.5 17.4477 9.5 18V22", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M14 6H10M14 9.5H10M14 13H10", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "3" }]
];

export default Building02Icon;
